import { ParsedReportParams } from '@ais-ui/websockets';
import { ReportType } from '../../../reportsTypes';
import { useCallback } from 'react';
import { findFilterTypeFromReport } from '../../utils/findFilterTypeFromReport';

interface Ship {
  name: string;
  mmsi: string;
  callsign: string;
  imo: string;
}

export function useInitializeFilter(
  report: ParsedReportParams | undefined,
  reportType: ReportType
) {
  return useCallback(() => {
    const initialFilterType = findFilterTypeFromReport(report, reportType);
    const filterObject: Record<string, string | string[] | boolean> = {};
    if (!initialFilterType || !reportType.filter) {
      return filterObject;
    }

    const filterItemsArray = reportType.filter[initialFilterType];
    if (!filterItemsArray) {
      return filterObject;
    }

    for (const filterItem of filterItemsArray) {
      if (initialFilterType === 'normal') {
        const filter = report?.params['FID'];
        filterObject[filterItem.name] = filter;
      } else if (initialFilterType === 'shiplist') {
        const shiplist = report?.params['SHPL'];
        filterObject[filterItem.name] = shiplist;
      } else if (initialFilterType === 'ship') {
        const ship = report?.params['TL'].map((ship: Ship) => ({
          name: ship.name,
          mmsi: ship.mmsi,
          callSign: ship.callsign,
          imo: ship.imo,
          type: '',
        }));
        filterObject[filterItem.name] = ship;
      } else if (initialFilterType === 'combined') {
        if (filterItem.name === 'shiplist') {
          const shiplist = report?.params['SHPL'];
          filterObject[filterItem.name] = shiplist;
        } else {
          const filter = report?.params['FID'];
          filterObject[filterItem.name] = filter;
        }
      } else {
        return filterObject;
      }
    }

    return filterObject;
  }, [report, reportType]);
}
